import localeFr from '@angular/common/locales/fr';
import { DecimalPipe, registerLocaleData } from '@angular/common';
import {
  ApplicationConfig,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { queryStateInterceptor } from './shared/interceptors/query-state.interceptor';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';

registerLocaleData(localeFr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([queryStateInterceptor])),
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    [DecimalPipe],
  ],
};
